module.exports = __webpack_public_path__ + "media/images/countrysquared/uz-dbb1447f16b9e5ada25edfb6e90f1596.svg";